<template>
    <div ref="productDetailsSection">
        <UiComponentTabs
            :items="productDetailsList"
            :fixed-tabs="showPinTabs"
            @update:tab="handleUpdateTab"
            type="scroll"
        />
    </div>
</template>

<script lang="ts" setup>
import type { IProduct } from "~/libs/types/api/product";
import DetailsList from "./details-list.vue";
import DetailsDescription from "./details-description.vue";
import Comments from "./comments/wrapper.vue";
import FAQs from "./comments/faqs.vue";

const props = defineProps({
    product: {
        type: Object as PropType<IProduct>,
        required: true,
    },
});

const productDetailsSection: Ref<HTMLDivElement | undefined> = ref();
const showPinTabs = ref(false);

const { top } = useElementBounding(productDetailsSection);

watch(top, (newTop) => {
    if (newTop < -50) showPinTabs.value = true;
    else showPinTabs.value = false;
});

const productDetails = computed(() => {
    return [
        {
            icon: "i-solar-list-arrow-down-broken",
            label: "توضیحات محصول",
            content: {
                component: DetailsDescription,
                props: { description: props.product.description },
            },
            active: !isUndefined(props.product.description),
        },
        {
            icon: "i-solar-documents-minimalistic-line-duotone",
            label: "جزئیات محصول",
            content: {
                component: DetailsList,
                props: { list: props.product.attributes },
            },
            active: !(isUndefined(props.product.attributes) || props.product.attributes.length === 0),
        },
        {
            icon: "i-solar-chat-line-line-duotone",
            label: "نظرات کاربران",
            content: {
                component: Comments,
                props: { comments: props.product.comments },
            },
            active: true,
        },
        {
            icon: "i-solar-question-square-line-duotone",
            label: "سوالات متداول",
            content: {
                component: FAQs,
                props: { list: props.product.faqs },
            },
            active: !(isUndefined(props.product.faqs) || props.product.faqs.length === 0),
        },
    ];
});

const productDetailsList = computed(() => {
    return useFilter(productDetails.value, { active: true });
});

function handleUpdateTab() {
    top.value = 150;
}
</script>

<style></style>
